export const roleEnum = {
  superadmin: "superadmin",
  author: "author",
  supervisor: "supervisor",
  student: "student",
};
